import { render, staticRenderFns } from "./ModalAlert.vue?vue&type=template&id=cf39194c&scoped=true"
import script from "./ModalAlert.vue?vue&type=script&lang=js"
export * from "./ModalAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf39194c",
  null
  
)

export default component.exports